import React from 'react';
import moment from 'moment-timezone';
import { useParams } from 'react-router-dom';
import usePromise from 'react-use-promise';

import EclipseLoader from '../../../components/EclipseLoader';
import NavBar, { View } from '../../../components/NavBar';
import { Button } from '../../../components/Button';

import * as api from '../../../api';
import * as logger from '../../../logger';
import { PatientRouteParams } from '../../router';
import formStyles from '../../FormStart/index.module.css';
import questionStyles from '../../../components/Question/index.module.css';
import defaultStyles from '../../../styles/formSetStyles.module.css';
import { useTranslation } from 'react-i18next';

const ReceiptPage: React.FC = () => {
  const { t } = useTranslation('login');
  const { authenticationCode } = useParams<PatientRouteParams>();
  const [receiptPayload, error, state] = usePromise(async () => {
    const { receiptUrl, encounterData } =
      await api.client.Previsit.getReceiptInfo(authenticationCode);
    return {
      receiptUrl,
      encounterStartTime: encounterData.startTime,
      timezone: encounterData.practice.timezone,
    };
  }, [authenticationCode]);

  if (state === 'pending') {
    return (
      <div className={formStyles.Form}>
        <NavBar view={View.Login} />
        <EclipseLoader message="Finding your receipt..." />
      </div>
    );
  }

  if (state === 'rejected') {
    if (error) {
      logger.error(error);
    }
    alert(t('somethingWentWrongRefreshOrContactSupport'));
    return null;
  }
  const { receiptUrl, encounterStartTime, timezone } = receiptPayload;

  const dateString = moment(encounterStartTime).tz(timezone).format('M/D');

  return (
    <>
      <NavBar view={View.Login} />
      <div className={formStyles.Form}>
        <div>
          <label htmlFor={`receipt-label`} className={questionStyles.Label}>
            {`Receipt for your visit on ${dateString}`}
          </label>
          <div className={defaultStyles.ButtonSubmitWrapper}>
            <Button
              id="sign-in-button"
              children="View receipt"
              onClick={() => window.open(receiptUrl)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ReceiptPage;
